<template>
  <div :style="{'height': height, 'width': width}">
    <Spin fix size="large" v-if="spinShow">
      <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
      <p>flash加载中...</p>
    </Spin>
    <div :style="{'height': height, 'width': width}" id="flashContainer"></div>
    <!-- 处理数据回显成echarts  -->
    <Modal :title="title" footer-hide v-model="showChart" width="50vw">
      <div v-if="showChart">
        <div class="flashChart" ref="flashChart"></div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "flasPlayer",
  props: {
    url: {
      required: true
    },
    width: {
      required: false,
      default: "100%"
    },
    height: {
      required: false,
      default: "100%"
    }
  },
  data () {
    return {
      spinShow: false,
      showChart: false,
      title: '',
      flashChart: null
    }
  },
  methods: {
    loadPlay: function () {
      this.spinShow = true
      let _this = this
      const ruffle = window.RufflePlayer.newest()
      const player = ruffle.createPlayer()
      const container = document.getElementById("flashContainer")
      container.appendChild(player)
      player.load({ url: _this.url, allowScriptAccess: true }).then(() => {
        console.info("Ruffle successfully loaded the file")
        player.play()
      }).catch(e => {
        console.error("Ruffle failed to load the file:", e)
      }).then(val => {
        _this.spinShow = false
      })
    },
    flashOpenWindow: function (tagName) {
      let _this = this
      this.title = tagName
      var dataBeginTime = "@startOfDay"
      var dataEndTime = "@now"
      let params = new this.$URLSearchParams()
      params.append("tagname", tagName)
      params.append("flashBeginTime", dataBeginTime)
      params.append("flashEndTime", dataEndTime)

      this.$axios.post("/api/flash/chart", params).then(res => {
        _this.showChart = true
        console.log('res', res)
        setTimeout(() => {
          _this.initChart(res || {})
        })
      }).catch(err => {
        console.log(err)
        _this.$Message.error("数据获取失败！")
      }).then(val => {
        if (_this.flashChart != null) _this.flashChart.resize()
      })
    },
    initChart: function (data) {
      console.log("initChart")
      this.flashChart = this.$echarts.init(this.$refs.flashChart)
      this.flashChart.clear()
      this.flashChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        color: this.$common.echartsColor || [],
        dataZoom: [
          {
            type: 'slider',
            show: (data.data || []).length > 30,
            start: 0,
            end: 100
          },
        ],
        grid: {
          left: "3%",
          // right: "4%",
          // bottom: "4%",
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data.xAxis || []
        },
        yAxis: {
          name: data.unit || '',
          type: 'value',
        },
        series: [
          {
            name: this.title,
            type: 'line',
            smooth: true,
            data: data.data || [],
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
            markLine: {
              data: [
                { type: 'average', name: 'Avg' },
                [
                  { symbol: 'none', x: '90%', yAxis: 'max' },
                  { symbol: 'circle', label: { position: 'start', formatter: 'Max' }, type: 'max', name: '最大值' }
                ],
                [
                  { symbol: 'none', x: '90%', yAxis: 'min' },
                  { symbol: 'circle', label: { position: 'start', formatter: 'Min' }, type: 'min', name: '最小值' }
                ]
              ]
            }
          }
        ]
      })

    }
  },
  mounted () {
    window.flashOpenWindow = this.flashOpenWindow
    let _this = this
    setTimeout(() => {
      console.log("url", _this.url)
      window.RufflePlayer = window.RufflePlayer || {}
      console.log("window.RufflePlayer", window.RufflePlayer)
      window.RufflePlayer.config = {
        // 	// Options affecting the whole page
        // publicPath: serverIp,
        polyfills: false,

        // Options affecting files only
        width: "100%",
        height: "100%",
        autoplay: "auto",
        unmuteOverlay: "visible",
        backgroundColor: null,
        letterbox: "fullscreen",
        warnOnUnsupportedContent: true,
        contextMenu: true,
        showSwfDownload: false,
        upgradeToHttps: window.location.protocol === "https:",
        maxExecutionDuration: { secs: 15, nanos: 0 },
        logLevel: "error",
        base: null,
        menu: true,
        salign: "",
        scale: "showAll",
        quality: "high"
      }
      _this.loadPlay()
    })
  }
};
</script>
<style scoped>
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.flashChart {
  width: 100%;
  height: 50vh;
}
</style>